import Cookies from 'js-cookie';
import {doResultListUpdate} from './_doResultListUpdate';


export var recoverFacetsFromURL = (fromHashChange) => {
    if ($(".chanel-banner").length > 0) {
        if (String(window.location).indexOf("#") > -1) {
            var prodIds = String(window.location).split("#")[1];
            var doCherryPick = false;
            var cherries = [];
            $(prodIds.split("+OR+")).each(function() {
                var cherry = $("[data-part-number='" + String(this) + "']");
                if (cherry.length > 0) {
                    doCherryPick = true;
                    cherries.push(cherry);
                }
            });
            if (doCherryPick) {
                $(".navigation-links").find("li").not($(".navigation-links").find("li").eq(0)).hide();
                $(".product-card").hide();
                var cherryCount = 0;
                $(cherries).each(function() {
                    $(".product-area > .row").find(".row").eq(Math.floor(cherryCount / 4)).append(this);
                    this.show();
                    this.find("[data-src]").each(function() {
                        $(this).attr("src", $(this).data("src"));
                    });
                    cherryCount++;
                });
            }
        }
    }

    if ($(".result-list-is-present").length > 0 && $(".chanel-banner").length == 0) {

    	//personalization initialization
		var willPersonalize = false;
		var willPersonalizeMyFavorite = false;
		if(window.superCat && window.isPersonalizationOn && $(".sessionstorage").length > 0){
			var thisSuperPersonalizationCookie = localStorage.getItem("personalization" + window.superCat);
			var thisSuperMyFavoriteBrand = localStorage.getItem("myFavoritespersonalization" + window.superCat);
			if(thisSuperPersonalizationCookie && thisSuperPersonalizationCookie != "" && $(".sessionstorage").length > 0 && sessionStorage.getItem("oldSesPz" + window.superCat) != ""){
				//see if number of points is greater than or equal to 3, the minimum to emphasize a brand
				var testNumber = thisSuperPersonalizationCookie.split("|")[0].split("&amp;").join("&").split(";")[1];
				willPersonalize = testNumber * 1 >= 3;
			}
			if(thisSuperMyFavoriteBrand && thisSuperMyFavoriteBrand != "" && $(".sessionstorage").length > 0 && sessionStorage.getItem("oldSesPz" + window.superCat) != "") willPersonalizeMyFavorite = true;
		}

		if((!willPersonalize && !willPersonalizeMyFavorite) || Cookies.get('zCountry') != 'US') $('.remove-no-pz').remove();

        if (String(window.location).indexOf("#") > -1) {
            var cachedURLParameters = String(window.location).split("#")[1];

            //clear out current state, wont matter for bookmark load, only back/forward
            $(".facet input").each(function() {
                $(this).data("dontfirecheck", "true").prop("checked", "").removeData("dontfirecheck");
            });

            $("#facetFilterList li").remove();
            $("#filteredBy,.filtered-by").hide();
            $(".clearAll").hide();

            var updatedPageSize = false;
            var updatedOrderBy = false;
            var setEmphasize = false;

            $(cachedURLParameters.split("&")).each(function() {
                var thisParam = this.split("=")[0];
                var thisValue = this.split("=")[1];

                if (thisParam == "pageSize" && !isNaN(thisValue)) {
                    $("#pageSize").val(thisValue);
                    updatedPageSize = true;
                }
                if (thisParam == "beginIndex" && !isNaN(thisValue)) {
                    $("#beginIndex").val(thisValue);
                }

                if (thisParam == "orderBy" && !isNaN(thisValue)) {
                    updatedOrderBy = true;
                    $("#orderBy").val(thisValue);
                    $("#desktopOrderBy").val(thisValue);
                }
                if (thisParam == "facet") {
                    $(unescape(thisValue).split("|")).each(function() {
                        if ($("#" + String(this)).length > 0) {
                            // if ($(".icheckbox_minimal").length == 0) {
                            //     $("#" + String(this)).prop("checked", "checked");
                            // } else {
                            $("#" + String(this)).data("dontfirecheck", "true").prop("checked", "checked").removeData("dontfirecheck");
                            // }
                            $("#filteredBy,.filtered-by").show();
                            $(".clearAll").show();
                            $("#facetFilterList").append('<li id="filter_' + $("#" + String(this)).attr("id") + '"><a data-twist="selected-filter-' + $("#" + String(this)).parents("li").find("label > span").data("prettyattr") + '"role="button" href="#" onclick="javascript:Dillards.facetRemoveLink(\'' + $("#" + String(this)).attr("id") + '\'); return false;"><span class="label label-default">' + $("#" + String(this)).parents("li").find("label > span").data("prettyattr") + '<i class="remove-filter">&times;</i></span></a></li>');
                         }
                    });
                }
                if (thisParam == "emphasize") {
                    $("#onLoadFacets").val("&emphasize=" + thisValue + $("#onLoadFacets").val());
                    setEmphasize = true;
                    $('.remove-no-pz').remove();
                }
                if (thisParam == "onlyCats") {
                    $("#onLoadFacets").val("&onlyCats=" + thisValue + $("#onLoadFacets").val());
                    window.onlyCatsString = thisValue;
                }
                if (thisParam == "onlyFlags") {
                    $("#onLoadFacets").val("&onlyFlags=" + thisValue + $("#onLoadFacets").val());
                }
            });

            if (!updatedOrderBy) $("#orderBy,#desktopOrderBy").val(1);

            if (Cookies.get("emphasize") && !setEmphasize) {
                $("#onLoadFacets").val("&emphasize=" + Cookies.get("emphasize") + $("#onLoadFacets").val());
            }

            if (!updatedPageSize) {
                $("#pageSize").val(96);
            }
          if ($(".tabletPage").length > 0) {
                $("#pageSize").val(48);
            }
            if ($(".mobilePage").length > 0) {
                $("#pageSize").val(30);
            }

            doResultListUpdate(fromHashChange);
        } else {
            //clear out current state, wont matter for bookmark load, only back/forward
            $(".facet input").each(function() {
                $(this).data("dontfirecheck", "true").prop("checked", "").removeData("dontfirecheck");
            });
            if ($("[data-seocolor]").length == 0) {
                $("#facetFilterList li").remove();
                $("#filteredBy,.filtered-by").hide();
                $(".clearAll").hide();
            }
            $("#orderBy,#desktopOrderBy").val(1);

            var defaultPageSize = 96;
                 if ($(".tabletPage").length > 0) {
                defaultPageSize = 48;
            }
            if ($(".mobilePage").length > 0) {
                defaultPageSize = 30;
            }

            $('#pageSize').val(defaultPageSize);
            $("#beginIndex").val("0");
            doResultListUpdate(fromHashChange);
        }
    }
};
